<script>
export default {
  props: {
    label: String
  }
}
</script>

<template>
  <div class="row">
    <label class="label">{{ label }}</label>
    <div class="inputs">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.row {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.label {
  /* MEMO: 幅は調整が必要かも */
  width: 250px;
  margin-right: 20px;
}

.inputs {
  display: flex;
  flex: 1;
  gap: 50px;
  align-items: center;
  justify-content: flex-start;
}

.slot-wrap {
    flex: 1 1 0;
    min-width: 0;
}

:deep(.el-form-item) {
  margin: 0;
}
</style>
